// extracted by mini-css-extract-plugin
module.exports = {"content":"response-step_content__rkB1l","tips":"response-step_tips__JSPjl"};